import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Workspace gate (Slack-style): a user with multiple org memberships must
 * pick an active workspace before using the app; a user with exactly one is
 * auto-selected; zero falls through (legacy no-org users keep working).
 */
const OrgGate = ({ children }) => {
  const { organizations, activeOrgId, setActiveOrgId, loading } = useAuth();
  const location = useLocation();

  useEffect(() => {
    if (organizations.length === 1 && activeOrgId !== organizations[0].id) {
      setActiveOrgId(organizations[0].id);
    }
  }, [organizations, activeOrgId, setActiveOrgId]);

  if (loading) {
    return null;
  }

  if (location.pathname === '/org-picker') {
    return children;
  }

  if (organizations.length >= 2 && !activeOrgId) {
    return <Navigate to="/org-picker" replace />;
  }

  return children;
};

export default OrgGate;
